import {motion} from "framer-motion";
import {Col, Row} from "reactstrap";
import {Card, CardContent, CardHeader} from "@mui/material";
import {FiRefreshCw, FiGift, FiRotateCw, FiArrowRight, FiClock} from "react-icons/fi";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {FormattedMessage} from "react-intl";

export default function VatiaCheckoutStep1(props)
{
    let height = 80;
    let top = 16;
    let ranges = null;
    let monthText = <span> / <FormattedMessage id={ 'abo.new.text.month' } defaultMessage={ 'Monat'} /></span>;

    if(props.planTitle != null && props.planTitle != '' && Object.keys(props.timeframeData).includes(props.planTitle)) {
        ranges = props.timeframeData[props.planTitle].map((range, index) => {
            return <Col xl={12} lg={12} md={12} xs={12} sm={12}>
                <Card variant="outlined"
                                         sx={{
                                             // maxWidth: 400,
                                             width: '100%',
                                             maxWidth:570,
                                             minHeight: 100,
                                             display: "inline-block",
                                             marginRight: 1,
                                             cursor: "pointer",
                                             fontWeight: 600,
                                             borderColor: index == props.selectedTimeframe ? "green" : props.cards[index]
                                         }}
                                         onClick={() => props.handleTimeframeUpdate(index, range.title, range.months, range.price)}
                // onMouseEnter={(event) => {var cards = this.state.cards; cards[index] = 'black'; this.setState({cards:cards })}}
                // onMouseLeave={(event) => {var cards = this.state.cards; cards[index] = 'grey'; this.setState({cards:cards })}}
            >
                <CardContent>
                        {props.width>props.breakpoint ?  <Row style={{minHeight: props.width>props.breakpoint?height:0}}>
                        <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                            <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:height, paddingTop:top-3,marginLeft:20}}>
                                {range.months == 1 ?
                                    <FiRefreshCw style={{color: props.selectedTimeframe == index ? '#000' : '#eee'}} size={48}/> :
                                    <FiClock style={{color: props.selectedTimeframe == index ? '#000' : '#eee'}} size={48}/>}
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={4} xs={4} style={{}}>
                            <div style={{display: "inline-block", float:"none", verticalAlign: "left", height:height, paddingTop:top}}>
                                <Typography sx={{color: "black", fontSize: 28, fontWeight:550}}>{range.title}</Typography>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                            <div style={{display: "inline-block", float:"none", verticalAlign: "middle", heeight:height, paddingTop:top-2}}>
                                <p style={{fontSize: 20, fontWeight: 500, margin: 0}}>CHF {range.price}.-{range.months == 1 ? monthText : null}</p>
                                <Typography sx={{color: "grey", fontSize: 14}}>{range.subtitle}</Typography>
                            </div>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                            <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:height, paddingTop:top-1}}>
                                <CheckCircleIcon style={{display:props.selectedTimeframe == index ? null : 'none', color: "green", marginTop: 15}}/>
                            </div>
                        </Col>
                        </Row> : <Row style={{minHeight: props.width>props.breakpoint?200:0}}>
                            <Col xl={6} lg={6} md={6} sm={6} xs={6} style={{marginTop:0, paddingTop: 0, height:50}}>
                                <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:30, paddingTop:11, marginRight:16, marginTop:0}}>
                                    {range.months == 1 ?
                                        <FiRefreshCw style={{color: props.selectedTimeframe == index ? '#000' : '#eee'}} size={36}/> :
                                        <FiClock style={{color: props.selectedTimeframe == index ? '#000' : '#eee'}} size={36}/>}
                                </div>
                                <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:30, paddingTop:9, marginTop:0}}>
                                    <Typography sx={{color: "black", fontSize: 28, fontWeight:550}}>{range.title}</Typography>
                                </div>
                                <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:10, paddingTop:0, paddingBottom:0, marginTop:0, marginLeft:18}}>
                                    <CheckCircleIcon style={{color: props.selectedTimeframe == index ? "green" : "#fff", marginTop: 11}}/>
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                                <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:70, paddingTop:5, paddingBottom: 35}}>
                                    <p style={{fontSize: 20, fontWeight: 500, margin: 0}}>CHF {range.price}.-{range.months == 1 ? monthText : null}</p>
                                    <Typography sx={{color: "grey", fontSize: 14}}>
                                        {range.subtitle}
                                    </Typography>
                                </div>
                                {/*<div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:10, paddingTop:22, paddingBottom:40, marginTop:0, marginLeft:20}}>*/}
                                {/*    <CheckCircleIcon style={{display:props.selectedTimeframe == index ? null : 'none', color: "green", marginTop: 0}}/>*/}
                                {/*</div>*/}
                            </Col>
                            {/*<Col xl={6} lg={6} md={6} sm={6} xs={6} style={{margin:0,padding:0, height:38}}>*/}
                            {/*    <div style={{display: "inline-block", float:"none", verticalAlign: "middle", height:10, paddingTop:22, paddingBottom:40, marginTop:0, marginLeft:20}}>*/}
                            {/*        <CheckCircleIcon style={{display:props.selectedTimeframe == index ? null : 'none', color: "green", marginTop: 0}}/>*/}
                            {/*    </div>*/}
                            {/*</Col>*/}
                        </Row>
                        }
                </CardContent>
            </Card>
            </Col>
        })
    }

    return (<motion.div
        className="box"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
    >
        <Row style={{marginRight:props.width>props.breakpoint ? 80 : 10, marginLeft: "auto", marginTop: 20,
            marginBottom: 30, width:"100%", maxWidth:570, paddingLeft:0, paddingRight:0}}>
            <form onSubmit={e => e.preventDefault()}>
                <Row style={{
                    // paddingLeft:110,
                    // paddingRight:70,
                }}>
                    {ranges}
                </Row>
                <Row style={{paddingTop:20, textAlign:"right", marginRight:0, marginLeft: "auto"}}>
                    {/*<button style={{backgroundColor:"#fff",border:0,borderRadius:4,color:"#e2e2e2",padding:6,marginTop:0,*/}
                    {/*    width: 50, height: 50, marginRight: 10, fontSize: 12}}*/}
                    {/*        onClick={() => {props.handleBack()}}>*/}
                    {/*    Zurück*/}
                    {/*</button>*/}
                    <button style={{backgroundColor:"#f19800",border:0,borderRadius:4,color:"#fff",
                        padding:6, marginTop:0, width: 150, height: 50, fontSize: 12, fontWeight: 600}}
                            onClick={() => {props.handleNext()}}>
                        <FormattedMessage id={ 'abo.new.button.continue.address' } defaultMessage={ 'Weiter zur Lieferadresse'} />
                    </button>
                </Row>
            </form>
        </Row>
    </motion.div>)
}